import React from "react";
import styled from "styled-components";

export interface OverflowEllipsisProps {
  text?: string | React.ReactNode;
  lines?: number;
}

const StyledWrapper = styled("div")<{ lines: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-height: ${({ lines }) => `calc(1.5em * ${lines})`};
`;

export const OverflowEllipsis = ({ text, lines = 1 }: OverflowEllipsisProps) => {
  return <StyledWrapper lines={lines}>{text}</StyledWrapper>;
};
